import { render, staticRenderFns } from "./BusinessCooperation.vue?vue&type=template&id=0fe2bf30&scoped=true"
import script from "./BusinessCooperation.vue?vue&type=script&lang=js"
export * from "./BusinessCooperation.vue?vue&type=script&lang=js"
import style0 from "./BusinessCooperation.vue?vue&type=style&index=0&id=0fe2bf30&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe2bf30",
  null
  
)

export default component.exports